export default "__VITE_ASSET__8bZOnV_t__"